import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useDistributionRegionReducer = () =>
  useSelector((state: ApplicationState) => state.distributionRegion);
